import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { closeManualPositionWarningDialog, useManualPositionWarningDialogState } from './state';

export const ManualPositionWarningDialog = () => {
  const { open, onConfirm, onCancel } = useManualPositionWarningDialogState();

  const handleCancel = () => {
    onCancel();
    closeManualPositionWarningDialog();
  };

  const handleConfirm = () => {
    onConfirm();
    closeManualPositionWarningDialog();
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs">
      <DialogTitle>This scan was manually corrected on the scanner.</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Applying a transformation will overwrite the manual adjustments of the user and may
          distort the desired alignment. Only proceed if you are certain this scan needs to be moved
          and it has been clarified with the customer.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleConfirm} color="error" variant="outlined">
          Transform anyway
        </Button>
        <Button onClick={handleCancel} color="primary" variant="contained">
          Cancel transformation
        </Button>
      </DialogActions>
    </Dialog>
  );
};
